export default (router) => {
    router.beforeEach((to, from, next) => {
        if(to.name && !from.name) {
            from.meta.subKey = to.name
        }
        if(to.path === '/') {
            next({name: 'login'})
        } else {
            next()
        }
    })
}